import http from '../http-common';

class EventDataService {
  getAll() {
    return http.get("/events");
  }

  get(id) {
    return http.get(`/events/edit/${id}`);
  }

  create(data) {
    return http.post("/events/add", data);
  }

  update(data) {
    return http.put(`/events/update`, data);
  }

  delete(id) {
    return http.put(`/events/delete/${id}`);
  }
}

export default new EventDataService();
